<template>
  <v-dialog :value="dialogCredRecebidos" persistent max-width="600">
    <v-card>
      <v-card-title class="font-weight-bold green lighten-4 primary--text"
        >Últimos Créditos Recebidos</v-card-title
      >
      <v-card-text class="mt-3">
        <v-data-table
          :items="creditos"
          :headers="headers"
          hide-default-footer
          no-data-text="Nenhum crédito recebido anteriormente"
          :disable-sort="$mq == 'sm'"
        >
          <template v-slot:[`item.mesano`]="{ item }">
            {{ item.mes }}/{{ item.ano }}
          </template>
          <template v-slot:[`item.saldo`]="{ item }">
            <v-chip
              color="green lighten-5"
              class="green--text font-weight-bold"
              >{{ formatarMoeda(item.saldo) }}</v-chip
            >
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          color="secondary"
          @click="setDialogCredRecebidos(false)"
          rounded
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { formatMoeda } from "@/global";

export default {
  props: {
    creditos: Array,
  },
  computed: mapState("home", ["dialogCredRecebidos"]),
  data: () => ({
    headers: [
      {
        text: "Mês/Ano",
        value: "mesano",
        align: "center",
      },
      {
        text: "Valor",
        value: "saldo",
        align: "center",
      },
    ],
  }),
  methods: {
    ...mapMutations("home", ["setDialogCredRecebidos"]),
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

<style>
</style>
